import { utils } from '@kurtosys/ksys-app-template';
import { IChartLegendProps } from '@kurtosys/ksys-app-components/dist/components/charting/ChartLegend/models';
import { computed, action } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { ILegendConfiguration } from '../models';
import { IDataRow } from '../../../models/IDataRow';

export class LegendStore extends StoreBase {
	static componentKey: 'legend' = 'legend';

	@computed
	get configuration(): ILegendConfiguration | undefined {
		if (this.storeContext && this.storeContext.appStore) {
			return this.storeContext.appStore.getComponentConfiguration(LegendStore.componentKey);
		}
	}

	@action
	async initialize(): Promise<void> {

	}

	@computed
	get data(): IDataRow[] {
		return this.storeContext.appStore.getData(this.configuration);
	}

	@computed
	get chartLegendProps(): IChartLegendProps {

		const data = this.data;
		console.log({ data });
		const colors = this.storeContext.appStore.getColors(data, this.configuration);
		const rawChartLegendProps = (this.configuration && this.configuration.chartLegendProps) || {};
		return utils.object.deepMergeObjects(rawChartLegendProps, {
			colors,
			data: data as any,
			formatters: this.configuration && this.configuration.formatters,
		});

	}
}